// utils.ts

export const roundToDecimalPlaces = (number: number): number => {
    return Math.ceil(number * 100) / 100;
};
